import React from 'react';
import ReferrerTable from './ReferrerTable';
import ReferrerRingChart from './ReferrerRingChart';
import EntityBreakdownCard from '../../../../../../../../shared/designSystem/components/EntityBreakdownCard';

// =============================================================================
// ReferrerDetails — V1 "Basket Items" section, rebuilt on the v2 shared
// primitives. Mirrors the V2 BasketItemDetails layout (and title) so the
// two tabs look architecturally identical side-by-side.
//
// Left: DataTable-backed revenue table (Product Name / Revenue / Quantity).
// Right: BreakdownRingChart donut by revenue, top-N aggregated. The donut
// is one *dimension* of the data, not the whole story — the table also
// surfaces Quantity prominently — so the card title stays just "Basket
// Items" rather than "by Revenue", matching V2.
// =============================================================================

const ReferrerDetails = ({ referrerData = [] }) => (
  <EntityBreakdownCard
    title="Basket Items"
    table={<ReferrerTable referrerData={referrerData} />}
    breakdownChart={<ReferrerRingChart data={referrerData} />}
  />
);

export default ReferrerDetails;
